import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
  Card,
  CardContent,
  Box,
  Divider,
  Tab,
  Tabs,
} from '@material-ui/core';

import SectionTab from 'constants/SectionTab';
import { ListViewSkeleton } from 'common/ui/skeleton-ui';
import DetailsListItem from 'modules2/components/DetailsListItem';
import { ShowMore } from 'modules2/components';

import container from './MainCard.conainer';
import NoData from "modules2/components/no-data";

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 345,
    marginBottom: 10,
    background: theme.palette.paperColor,
    color: theme.palette.textColor,
  },
  tabRoot: {
    color: theme.palette.textColor1,
    '& .MuiTabs-indicator': {
      backgroundColor: theme.palette.pink,
    },
  },
  tabButton: {
    color: theme.palette.textColor,
    fontFamily: 'Arial',
    minHeight: 48,
    '& .MuiTab-wrapper': {
      alignItems: 'initial',
      flexDirection: 'row',
    },
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    marginTop: 10,
  },
  circularProgress: {
    position: 'relative',
    textAlign: 'center',
  },
}));

const tabList = [
  {
    id: 0,
    name: SectionTab.RadioFavourite,
  },
  {
    id: 1,
    name: SectionTab.RadioHistory,
  },
];

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box style={{ padding: 0 }}>
            {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const MainCard = (props) => {
  const classes = useStyles();
  const {
    userState: { firstName },
    radioState: { loading, radios, mostPopular },
    radioHistoryState: {
      history,
      historyStationIds,
      heartedStationIds,
      heartsNext,
      historyNext,
      historyLoading,
      heartedLoading,
    },
    onGetNextFavoriteStart,
    onGetNextHistoryStart,
    onViewRadioPlayerStart,
    onDeleteHistoryRadioStation,
    onFavouriteRadioStation,
    onDeleteFavoriteRadioStation,
    onShowSnackbarNotification,
    onSetCurrentTab,
  } = props;
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const onClickHandler = (id) => {
    onViewRadioPlayerStart(id);
  };

  const onDeleteClick = (object) => {
    switch (value) {
      case 0:
        onShowSnackbarNotification(`Radio Unhearted 😢`);
        onDeleteFavoriteRadioStation(object.stationuuid);
        break;
      case 1:
        onShowSnackbarNotification(`Radio deleted from history 😢`);
        onDeleteHistoryRadioStation(object.stationuuid);
        break;
      default:
        console.warn('Unknown case: ', value);
        break;
    }
  };

  const onFavouriteClick = (id) => {
    if (heartedStationIds.some((radio) => radio === id)) {
      onShowSnackbarNotification(`Radio Unhearted 😢`);
      onDeleteFavoriteRadioStation(id);
    } else {
      onShowSnackbarNotification(`Radio Hearted ❤️`);
      onFavouriteRadioStation(id);
    }
  };

  const displayArticleList = (skeletonLoading) => {
    let list;
    let nextValue;
    let message;
    let loading;
    switch (value) {
      case 0:
        loading = heartedLoading;
        list = heartedStationIds;
        nextValue = heartsNext;
        message = `Hey ${firstName ? firstName : 'there'}, you don\'t have any hearted radio yet.`;
        break;
      case 1:
        loading = historyLoading;
        list = historyStationIds;
        nextValue = historyNext;
        message = `Hey ${firstName ? firstName : 'there'}, you don\'t have any history yet.`;
        break;
      default:
        console.warn('Unknown case: ', value);
        break;
    }

    if (skeletonLoading || loading) {
      return [...Array(3)].map((_, idx) => {
        return <ListViewSkeleton key={idx} />;
      });
    }

    const items = list
      .map((id) => history[id])
      .filter((x) => !_.isEmpty(x) && !_.isNil(x));

    return items.length ? (
      items
        .reverse()
        .slice(0, nextValue)
        .map((radio) => {
          return (
            <DetailsListItem
              editable
              hearted={!tabList.findIndex((obj) => obj.id === value)}
              key={radio.stationuuid}
              stationid={radio.stationuuid}
              isPlayed={false}
              isPinned={false}
              image={radio.favicon}
              title={radio.name}
              subtitle={radio.tags}
              url={radio.url_resolved}
              radio_id={radio.stationuuid}
              radio={radio}
              onClick={onClickHandler}
              onDeleteClick={onDeleteClick}
              onFavouriteClick={onFavouriteClick}
            />
          );
        })
    ) : (
      <NoData
        loading={skeletonLoading}
        message={message}
        radios={radios}
        mostPopular={mostPopular}
        onClickHandler={onClickHandler}
        // onDeleteClick={onDeleteClick}
        onFavouriteClick={onFavouriteClick}
        onSetCurrentTab={onSetCurrentTab}
      />
    );
  };

  useEffect(() => {
    moreOnCurrentTab();
  }, [heartsNext, historyNext]);

  const moreOnCurrentTab = () => {
    switch (value) {
      case 0:
        return heartedStationIds.length > heartsNext;
      case 1:
        return historyStationIds.length > historyNext;
      default:
        console.warn('Unknown case:', value);
        return false;
    }
  };

  const onClickSeeMore = () => {
    if (!moreOnCurrentTab()) {
      return;
    }

    switch (value) {
      case 0:
        return onGetNextFavoriteStart(heartsNext, 3);
      case 1:
        return onGetNextHistoryStart(historyNext, 3);
      default:
        console.warn('Unknown case:', value);
        return;
    }
  };

  return (
    <Card className={classes.root}>
      <CardContent style={{ padding: 0, minHeight: 485, }}>
        <Tabs
          value={value}
          onChange={handleChange}
          className={classes.tabRoot}
          variant={'fullWidth'}
        >
          <Tab
            label="Hearted"
            className={classes.tabButton}
            {...a11yProps(
              tabList.findIndex((obj) => obj.name === SectionTab.RadioFavourite)
            )}
          />
          <Tab
            label="History"
            className={classes.tabButton}
            {...a11yProps(
              tabList.findIndex((obj) => obj.name === SectionTab.RadioHistory)
            )}
          />
        </Tabs>
        <Divider />
        {tabList.map((item, index) => {
          return (
            <TabPanel value={value} index={index} key={index}>
              {/*{item === 0 ? 'Page One' : 'Page Two'}*/}
              <div className={classes.container}>
                {displayArticleList(loading)}
              </div>
            </TabPanel>
          );
        })}
        {moreOnCurrentTab() && <ShowMore nextRadioList={onClickSeeMore} />}
      </CardContent>
    </Card>
  );
};

export default container(MainCard);
